import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramDispensingHistoryPage } from './program-dispensing-history';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  declarations: [
    ProgramDispensingHistoryPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramDispensingHistoryPage),
    NgxDatatableModule
  ],
})
export class ProgramDispensingHistoryPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-dispensing-history/program-dispensing-history.module.ts